import { motion } from 'framer-motion';

import { defaultMotionProps } from './motion';

export const Driving = () => {
  return (
    <section className="bg-electric-03 relative">
      <div className="max-w-[1460px] p-main relative mx-auto grid ml:grid-cols-2 gap-40 py-60 ml:py-150">
        <motion.div
          className="max-w-[570px] ml:sticky ml:top-100 self-start text-charcoal"
          {...defaultMotionProps}
        >
          <h2 className="ml:text-[65px] text-[32px] font-normal leading-[94%] tracking-[-0.65px]">
            Driving{' '}
            <span className="text-cipher-05">operational efficiency & ROI</span>
          </h2>
          <p className="ml:text-[21px] text-[16px] font-light leading-[136%] mt-20">
            This year, our customers drove significant efficiency gains across
            engineering, security, sales operations, marketing, and customer
            support teams through smart automation: reducing manual work,
            reclaiming resources for strategic initiatives, and delivering
            measurable business growth.
          </p>
        </motion.div>
        <motion.div
          className="rounded-23 ml:rounded-50 p-20 ml:p-48 text-cloud ml:text-[32px] text-[18px] font-normal leading-[105%] tracking-[-0.32px] text-pretty bg-electric-07 flex gap-24 flex-col"
          {...defaultMotionProps}
          transition={{ ...defaultMotionProps.transition, delay: 0.1 }}
        >
          <div>
            <span className="ml:text-[79px] text-[40px] font-normal leading-[105%] tracking-[-0.79px] trim-text text-electric-05 mb-8">
              $960M
            </span>
            <span className="block">
              saved<sup>&dagger;</sup>
            </span>
          </div>
          <div>
            <span className="ml:text-[79px] text-[40px] font-normal leading-[105%] tracking-[-0.79px] trim-text text-electric-05 mb-to8">
              14M
            </span>
            <span className="block">
              total hours reclaimed<sup>&dagger;</sup>
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
